<template>   
    <section class="colorlib-skills" data-section="skills">
        <div class="colorlib-narrow-content">
            <div class="row">
                <div class="col-md-6 col-md-offset-3 col-md-pull-3 animate-box" data-animate-effect="fadeInLeft">
                    <span class="heading-meta">My Specialty</span>
                    <h2 class="colorlib-heading animate-box">My Skills</h2>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 animate-box" data-animate-effect="fadeInLeft">
                    <div class="progress-wrap">
                        <h3>HTML5</h3>
                        <div class="progress">
                            <div class="progress-bar color-1" role="progressbar" aria-valuenow="75"
                            aria-valuemin="0" aria-valuemax="100" style="width:75%">
                            <span>75%</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 animate-box" data-animate-effect="fadeInRight">
                    <div class="progress-wrap">
                        <h3>CSS</h3>
                        <div class="progress">
                            <div class="progress-bar color-2" role="progressbar" aria-valuenow="60"
                            aria-valuemin="0" aria-valuemax="100" style="width:60%">
                            <span>60%</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 animate-box" data-animate-effect="fadeInLeft">
                    <div class="progress-wrap">
                        <h3>JavaScript</h3>
                        <div class="progress">
                            <div class="progress-bar color-3" role="progressbar" aria-valuenow="60"
                            aria-valuemin="0" aria-valuemax="100" style="width:60%">
                            <span>60%</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 animate-box" data-animate-effect="fadeInRight">
                    <div class="progress-wrap">
                        <h3>Bootstrap</h3>
                        <div class="progress">
                            <div class="progress-bar color-4" role="progressbar" aria-valuenow="75"
                            aria-valuemin="0" aria-valuemax="100" style="width:75%">
                            <span>75%</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 animate-box" data-animate-effect="fadeInLeft">
                    <div class="progress-wrap">
                        <h3>Vue.js</h3>
                        <div class="progress">
                            <div class="progress-bar color-5" role="progressbar" aria-valuenow="65"
                            aria-valuemin="0" aria-valuemax="100" style="width:65%">
                            <span>65%</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 animate-box" data-animate-effect="fadeInRight">
                    <div class="progress-wrap">
                        <h3>Vuex</h3>
                        <div class="progress">
                            <div class="progress-bar color-6" role="progressbar" aria-valuenow="50"
                            aria-valuemin="0" aria-valuemax="100" style="width:50%">
                            <span>50%</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 animate-box" data-animate-effect="fadeInRight">
                    <div class="progress-wrap">
                        <h3>VueRouter</h3>
                        <div class="progress">
                            <div class="progress-bar color-3" role="progressbar" aria-valuenow="80"
                            aria-valuemin="0" aria-valuemax="100" style="width:80%">
                            <span>80%</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 animate-box" data-animate-effect="fadeInRight">
                    <div class="progress-wrap">
                        <h3>Vuetify</h3>
                        <div class="progress">
                            <div class="progress-bar color-2" role="progressbar" aria-valuenow="70"
                            aria-valuemin="0" aria-valuemax="100" style="width:70%">
                            <span>70%</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 animate-box" data-animate-effect="fadeInRight">
                    <div class="progress-wrap">
                        <h3>Quasar</h3>
                        <div class="progress">
                            <div class="progress-bar color-5" role="progressbar" aria-valuenow="55"
                            aria-valuemin="0" aria-valuemax="100" style="width:55%">
                            <span>55%</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 animate-box" data-animate-effect="fadeInRight">
                    <div class="progress-wrap">
                        <h3>MySQL</h3>
                        <div class="progress">
                            <div class="progress-bar color-4" role="progressbar" aria-valuenow="50"
                            aria-valuemin="0" aria-valuemax="100" style="width:50%">
                            <span>50%</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 animate-box" data-animate-effect="fadeInRight">
                    <div class="progress-wrap">
                        <h3>APIs</h3>
                        <div class="progress">
                            <div class="progress-bar color-3" role="progressbar" aria-valuenow="50"
                            aria-valuemin="0" aria-valuemax="100" style="width:50%">
                            <span>50%</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 animate-box" data-animate-effect="fadeInRight">
                    <div class="progress-wrap">
                        <h3>Responsive web design</h3>
                        <div class="progress">
                            <div class="progress-bar color-2" role="progressbar" aria-valuenow="70"
                            aria-valuemin="0" aria-valuemax="100" style="width:70%">
                            <span>70%</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 animate-box" data-animate-effect="fadeInRight">
                    <div class="progress-wrap">
                        <h3>GitHub</h3>
                        <div class="progress">
                            <div class="progress-bar color-1" role="progressbar" aria-valuenow="65"
                            aria-valuemin="0" aria-valuemax="100" style="width:65%">
                            <span>65%</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    export default{
        // eslint-disable-next-line vue/multi-word-component-names
        name: "Skills"
    }
</script>